import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { RequireRole } from './auth/RequireRole';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { ScenarioListPage } from './features/scenarios/ScenarioListPage';
import { CalculatorPage } from './features/calculator/CalculatorPage';
import { AdminPage } from './features/admin/AdminPage';
import { NotFoundPage } from './features/NotFoundPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AppShell>
        <DashboardPage />
      </AppShell>
    ),
  },
  {
    path: '/scenarios',
    element: (
      <AppShell>
        <ScenarioListPage />
      </AppShell>
    ),
  },
  {
    path: '/scenarios/:id',
    element: (
      <AppShell>
        <CalculatorPage />
      </AppShell>
    ),
  },
  {
    path: '/admin',
    element: (
      <AppShell>
        <RequireRole requiredRole="Admin">
          <AdminPage />
        </RequireRole>
      </AppShell>
    ),
  },
  { path: '/index.html', element: <Navigate to="/" replace /> },
  {
    path: '*',
    element: (
      <AppShell>
        <NotFoundPage />
      </AppShell>
    ),
  },
]);
